/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Loader, useModal } from '@jutro/components';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useTranslator } from '@jutro/locale';
import { MSBService } from 'gw-capability-gateway';
import { TFPACustomQuoteService } from 'tfpa-capability-quoteandbind-residential';
import CommonQuoteInfoMessages from "gw-capability-quoteandbind-common-react/components/CommonQuoteInfo/CommonQuoteInfo.messages";
import metadata from './QuotePage.metadata.json5';
import msbInfoUtil from 'ent-capability-quoteandbind-common-react/util/MsbInfoUtil.js';
import UWUtil from "ent-capability-quoteandbind-common-react/util/UWUtil"
import UnderwritingWarningComponent from "ent-capability-quoteandbind-common-react/components/UnderwritingWarningComponent/UnderwritingWarningComponent";
import Offerings from '../../components/Quote/Offerings/Offerings'
import styles from './QuotePage.module.scss';
import messages from './QuotePage.messages';
import QuotePremium from '../../components/Quote/QuotePremium/QuotePremium';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import TWIAJobHelper from 'ent-capability-quoteandbind-common-react/util/TWIAJobHelper';
import TFPACoverablesUtils from '../../util/TFPACoverablesUtils';
import GatewayEndorsementService from '../../../../capabilities/twia-capability-gateway-policychange/services/GatewayEndorsementService';

function TFPAQuotePage(props) {
    const { authHeader } = useAuthentication();
    const [isLoading, setIsLoading] = useState(false);
    const [termClausePublicID, setTermClausePublicID] = useState();
    const [isCovLoading, setIsCovLoading] = useState(false);
    const { showAlert } = useModal();
    const [continueButton, setContinueButton] = useState(false);
    const {
        wizardData: submissionVM,
        updateWizardData,
        steps
    } = props;
    const QUOTE_PAGE = 'TFPAQuotePage';
    const { onValidate, isComponentValid } = useValidation(QUOTE_PAGE);
    const [showError, setShowError] = useState(false);
    const [offeredQuote, setOfferedQuote] = useState();
    const breakpoint = useContext(BreakpointTrackerContext);
    const LOB_CODE = 'homeowners_tfpa';
    const translator = useTranslator();
    const [offeringsVM, setOfferingsVM] = useState();
    const [currentIndex, setCurrentIndex] = useState();
    const [currentOfferingVM, setCurrentOfferingVM] = useState();
    const [showAdditionalFieldError, setShowAdditionalFieldError] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorDescription, setShowErrorDescription] = useState();
    const policyTypeCode = submissionVM.lobData.homeowners_tfpa?.policyType_TWIA?.value?.code ||
        submissionVM.lobData.homeowners_tfpa.coverables.policyType_Ext?.value?.code;
    const [discSurgValue, setDiscSurgValue] = useState([]);
    const [insuredValue, setInsuredValue] = useState([]); // DE16446
    // DE16447
    const [ho205CovDesc, setHo205CovDesc] = useState([]);
    const [ho205CovValue, setHo205CovValue] = useState([]);
    const [showUWComponent, setShowUWComponent] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        if (steps[6].visited !== false) {
            setContinueButton(true)
            setIsLoading(false);
        }
        else {
            setIsLoading(false);
        }
        const premiumValue = _.get(submissionVM, 'quoteData.offeredQuotes.value[0].premium.total.amount')
        const quoteData = submissionVM.quoteData.value;
        const customOfferedQuotes = quoteData.offeredQuotes.filter(quote => quote.isCustom);

        if (premiumValue) {
            setContinueButton(true);
            setDiscSurgValue(_.get(submissionVM, 'lobData.homeowners_tfpa.coverages.discountsSurchargesAndFees_Ext.value'))
            setInsuredValue(_.get(submissionVM, 'lobData.homeowners_tfpa.coverages.additionalInsureds_Ext.value'))
            setHo205CovDesc(_.get(submissionVM, 'lobData.homeowners_tfpa.coverages.homeOfficeLiabDesc_Ext.value'))
            setHo205CovValue(_.get(submissionVM, 'lobData.homeowners_tfpa.coverages.medPayOthers_Ext.value'))
        }

        // DE17975
        if (_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value') !== undefined &&
            UWUtil.checkUWIssues(_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value')) &&
            _.get(submissionVM, 'baseData.periodStatus.value.code') === 'Quoted') {
            setShowUWComponent(true)
        }

        setOfferedQuote(() => _.first(customOfferedQuotes));
        //submissionVM.lobData.homeowners_tfpa.isMSBUrlAvailable = false;
        // msbInfoUtil(submissionVM, updateWizardData, authHeader).checkMSBUrlAvailability();
    }, []);

    const setCoverageValidation = useCallback((isValid, clauseID) => {
        if (onValidate) {
            onValidate(isValid, clauseID)
        }
    }, [onValidate]);

    const quotePrintDocument = useCallback(() => {
        window.print();
    }, []);

    const buildCustomQuote = useCallback(() => {
        const coverages = submissionVM.lobData.homeowners_tfpa.coverages.value
        const customQuote = {
            quote: offeredQuote,
            coverages: {},
            quoteID: submissionVM.quoteID?.value || submissionVM.jobID?.value,
            sessionUUID: submissionVM.sessionUUID.value,
            periodStart: submissionVM.baseData.periodStartDate.value,
            periodEnd: submissionVM.baseData.periodEndDate.value,
            errorsAndWarnings: {}
        };
        // eslint-disable-next-line security/detect-object-injection
        customQuote.coverages[LOB_CODE] = coverages;
        return customQuote;
    }, [offeredQuote, submissionVM]);

    const updateCustomQuote = useCallback(() => {
        setIsLoading(true);

        const customQuoteRequest = buildCustomQuote();
        let quoteResult;
        if (TWIAJobHelper.isPolicyChange(submissionVM.value)) {
            quoteResult = GatewayEndorsementService.quoteEndorsement([submissionVM.jobID.value],
                authHeader);
        } else {
            quoteResult = TFPACustomQuoteService.updateCustomQuote(customQuoteRequest, authHeader);
        }

        quoteResult.then((response) => {

            if (response.errorsAndWarnings) {
                const { validationIssues } = response.errorsAndWarnings;

                if (validationIssues && validationIssues.issues && validationIssues.issues.length > 0) {
                    if (validationIssues.issues[0].flowStepId === "HOCoverages") {
                        setShowErrorMessage(true);
                        setShowErrorDescription(validationIssues.issues[0].reason);
                        setIsLoading(false);

                        return;
                    }

                    if (validationIssues.issues[0].reason.includes('no coverages')) {
                        setShowErrorMessage(true);
                        setShowErrorDescription(translator(messages.noCoveragesSelected));
                        setIsLoading(false);

                        return;
                    }
                    // DE16568
                    const dwellingError = validationIssues.issues.find((issue) => issue.relatedEntity.type === 'entity.DwellingCov_HOE')
                    if (dwellingError !== undefined) {
                        setShowErrorMessage(true);
                        setShowErrorDescription(translator(messages.dwellingError));
                        setIsLoading(false);

                        return;
                    }

                    // US29141, DE18254
                    const occupancyError = validationIssues.issues.find((issue) => issue
                        .relatedEntity.type === "entity.Dwelling_HOE" 
                        || issue.relatedEntity.type === "entity.PolicyAddlInsuredCovHOE_Ext")
                    if (occupancyError !== undefined && (_.includes(occupancyError?.reason,
                        'occupancy') || _.includes(occupancyError?.reason,
                            'Occupancy'))) {
                        setIsLoading(false);
                        showAlert({
                            title: messages.occupancyErrorTitle,
                            message: occupancyError.reason,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: CommonQuoteInfoMessages.cancel,
                        })
                        return;
                    }
                }
            }

            setShowErrorMessage(false);
            setShowErrorDescription(null);

            if (TWIAJobHelper.isSubmission(submissionVM.value)) {
                const offeredQuoteNew = response.quote;

                setDiscSurgValue(response.coverages.homeowners_tfpa.discountsSurchargesAndFees_Ext)
                setInsuredValue(response.coverages.homeowners_tfpa.additionalInsureds_Ext)
                setHo205CovDesc(response.coverages.homeowners_tfpa.homeOfficeLiabDesc_Ext) // DE16447
                setHo205CovValue(response.coverages.homeowners_tfpa.medPayOthers_Ext)
                _.set(submissionVM, 'lobData.homeowners_tfpa.coverages.value', response.coverages[LOB_CODE]);
                _.set(submissionVM, 'quoteData.offeredQuotes.value[0]', offeredQuoteNew);
                _.set(submissionVM.value, 'baseData.periodStatus', response.quote.status) // DE16366
                _.set(submissionVM, 'errorsAndWarnings.value', response.errorsAndWarnings)
                setOfferedQuote(offeredQuoteNew)
            } else {
                submissionVM.value = response
                const offeredQuoteUpdated = _.get(submissionVM, 'quoteData.offeredQuotes.value[0]');
                setOfferedQuote(offeredQuoteUpdated);
                setDiscSurgValue(response.lobData.homeowners_tfpa.coverages.discountsSurchargesAndFees_Ext)
                setInsuredValue(response.lobData.homeowners_tfpa.coverages.additionalInsureds_Ext)
                setHo205CovDesc(response.lobData.homeowners_tfpa.coverages.homeOfficeLiabDesc_Ext) // DE16447
                setHo205CovValue(response.lobData.homeowners_tfpa.coverages.medPayOthers_Ext)
            }

            // DE17975
            if (_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value') !== undefined && 
            UWUtil.checkUWIssues(_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value'))) {
                setShowUWComponent(true)
            }

            setContinueButton(true);
            updateWizardData(submissionVM);
            setShowAdditionalFieldError(false);   
            setIsLoading(false)
        }).catch((error) => {
            setIsLoading(false);
            ErrorPopupUtil.showQuoteErrorPopup(showAlert, false);
        })
    }, [authHeader, buildCustomQuote, showAlert, submissionVM, translator, updateWizardData]);

    const onValueChange = useCallback(async (newValue, path, clause) => {
        setIsLoading(true);
        if (clause) {
            setTermClausePublicID(() => clause.publicID);
        }
        if (_.includes(path, 'homeOfficeLiabDesc_Ext')) {
            setShowAdditionalFieldError(true)
            setContinueButton(false)
        }
        const index = path.lastIndexOf(".");
        const newPath = path.substring(0, index);

        // eslint-disable-next-line no-secrets/no-secrets
        if (index >= 0 && !_.includes(path, 'homeOfficeLiabCoverage_Ext')) {
            _.set(submissionVM, `${newPath}.updated`, true);
        }

        _.set(submissionVM, path, newValue);
        updateWizardData(submissionVM);
        setIsLoading(false);

    }, [submissionVM, updateWizardData])

    const syncCoverages = useCallback(() => {
        setIsLoading(true);
        let updateCoverages;
        const customQuoteRequest = buildCustomQuote();
        if (TWIAJobHelper.isPolicyChange(submissionVM.value)) {
            updateCoverages = GatewayEndorsementService.updateCoverages(submissionVM.jobID.value,
                customQuoteRequest.coverages,
                authHeader);
        } else {
            updateCoverages = TFPACustomQuoteService.updateCustomQuoteCoverages(customQuoteRequest,
                authHeader);
        }

        updateCoverages.then((response) => {
            setShowError(true);
            setContinueButton(false);
            setShowAdditionalFieldError(false);
            if (TWIAJobHelper.isSubmission(submissionVM.value)) {
                // eslint-disable-next-line security/detect-object-injection
                _.set(submissionVM, 'lobData.homeowners_tfpa.coverages.value', response.coverages[LOB_CODE]);
                submissionVM.value.errorsAndWarnings = response.errorsAndWarnings;
                _.set(submissionVM, 'quoteData.offeredQuotes.value[0]', response.quote);
                setOfferedQuote(response.quote)
            } else {
                submissionVM.value = response
                const offeredQuoteUpdated = _.get(submissionVM, 'quoteData.offeredQuotes.value[0]');
                setOfferedQuote(offeredQuoteUpdated)
            }
            updateWizardData(submissionVM);
            setIsCovLoading(null);
            setIsLoading(false);
        }).catch(() => {
            setIsCovLoading(null);
            setIsLoading(false);
            setContinueButton(false);
            setShowAdditionalFieldError(true);
            setShowError(true);
            showAlert({
                title: messages.paymentRequestFailed,
                message:
                    messages.sorryYourPaymentCouldNotBeProcessedAtThisTime,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: CommonQuoteInfoMessages.close,
            })
        });
    }, []);

    const onValueChangeAndSync = useCallback(async (newValue, path, clause) => {
        if (!_.isUndefined(newValue) && !_.isUndefined(path)) { await onValueChange(newValue, path); }
        setContinueButton(false);
        setShowAdditionalFieldError(true);
        // eslint-disable-next-line no-secrets/no-secrets
        if (_.includes(path, 'homeOfficeLiabCoverage_Ext') && newValue === true) {
            setShowAdditionalFieldError(false);
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverages.homeOfficeLiabDesc_Ext.value', null);
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverages.medPayOthers_Ext.value', null);
            updateWizardData(submissionVM);
            return;
        }

        // if (!clause) {
        //     setIsCovLoading(() => termClausePublicID);
        // } else if (clause?.publicID) {
        //     setIsCovLoading(clause.publicID);
        // } else {
        //     setIsLoading(true);
        // }
        syncCoverages();

    }, [authHeader, buildCustomQuote, onValueChange, showAlert, submissionVM, updateWizardData]);

    const onReviewUpdateMSB = useCallback(() => {
        msbInfoUtil(submissionVM, updateWizardData, authHeader).loadValuationTFPA(showAlert, translator);
    }, [submissionVM, updateWizardData, authHeader]);

    const onRefreshValuation = useCallback(() => {
        const updatedValues = msbInfoUtil(submissionVM, updateWizardData, authHeader).getUpdatedValuationTFPA(showAlert, translator);
        if (updatedValues) {
            syncCoverages();
        }
    }, [submissionVM, updateWizardData, authHeader]);

    // DE16297
    // const cashValueVisible = useCallback(() => {
    //     const constructionType = TFPACoverablesUtils.getConstructionType(submissionVM);

    //         return ((policyTypeCode === 'DP2' || policyTypeCode === 'HO3') 
    //         && constructionType !== 'MH_ext');
    // }, [policyTypeCode, submissionVM]);

    const hideEstimatedValue = useCallback(() => {
        if (policyTypeCode === 'HO4' || policyTypeCode === 'HO6') {
            return true;
        }

        return TFPACoverablesUtils.getConstructionType(submissionVM) === 'MH_ext';
    }, [policyTypeCode, submissionVM]);

    const showUWWarningComponent = useCallback(() => {
        if (_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value') !== undefined) {
            return UWUtil.checkUWIssues(_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value'))
        }

        return false
    }, [submissionVM])

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        offeringDetails: {
            visible: !_.isUndefined(offeredQuote),
            submissionVM,
            onValueChange,
            onValueChangeAndSync,
            isCovLoading,
            showError,
            updateWizardData,
            setCoverageValidation,
            isComponentValid,
            setCurrentIndex,
            setCurrentOfferingVM,
            showAdditionalFieldError,
            discSurgValue, // DE16262
            offeredQuote,
            isTFPACoverageSummary: false,
            authHeader,
            insuredValue, // DE16446
            ho205CovValue,
            ho205CovDesc, // DE16447
        },
        premiumCard: {
            submissionVM,
            isComponentValid,
            updateCustomQuote,
            offeredQuote,
            showError, // DE15658
            continueButton,
            showAdditionalFieldError
        },
        msbValue: {
            value: TFPACoverablesUtils.msbValue(submissionVM)
        },
        actualCashValue: {
            value: TFPACoverablesUtils.actualCashValue(submissionVM)
        },
        msbContainer: {
            visible: policyTypeCode === 'DP2' || policyTypeCode === 'HO3'
        },
        reviewUpdateMSB: {
            visible: TWIAJobHelper.isPolicyChange(submissionVM.value) ? false : TFPACoverablesUtils.valuationCompleted(submissionVM)
        },
        refreshValuation: { // DE17851
            visible: TWIAJobHelper.isPolicyChange(submissionVM.value) ? false : msbInfoUtil(submissionVM, updateWizardData, authHeader).isRefreshMSBAvailable_TFPA()
        },
        cashValue: {
            visible: !hideEstimatedValue()
        },
        space: {
            visible: !hideEstimatedValue()
        },
        infoMessage: {
            visible: showErrorMessage,
            message: errorDescription
        },
        quotePageInstructions:{
            content: TWIAJobHelper.isPolicyChange(submissionVM.value) 
            ? translator(messages.permiumBoxChangeTitle) 
            : translator(messages.permiumBoxSubTitle) // DE17777
        },
        UnderwritingWarning: {
            submissionVM,
            visible: showUWWarningComponent() && showUWComponent
        },
    };

    const onNext = () => {
        setIsLoading(false);

        return submissionVM;
    }

    const resolvers = {
        resolveCallbackMap: {
            quotePrintDocument,
            onReviewUpdateMSB,
            onRefreshValuation
        },
        resolveComponentMap: {
            offeringComponent: Offerings,
            premiumCardComponent: QuotePremium,
            UnderwritingWarningComponent: UnderwritingWarningComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <WizardPage
            showPrevious
            showCancel={false}
            showNext={continueButton}
            nextLabel={translator(messages.continueLabel)}
            previousLabel={translator(messages.backToTopLabel)}
            onNext={onNext}
            disableNext={showUWWarningComponent()}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    showErrors={showError || showAdditionalFieldError}
                    model={submissionVM}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </Loader>
        </WizardPage>
    );
}

TFPAQuotePage.propTypes = wizardProps;
export default TFPAQuotePage;
